var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home"
  }, [_vm.showLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "home__content"
  }, [_vm._m(0), _c('div', {
    staticClass: "title title__top"
  }, [_vm._v("Hi, "), _c('b', [_vm._v(_vm._s(_vm.user.name))])]), _c('div', {
    staticClass: "title title__bottom"
  }, [_vm._v(" 再邀請 "), _c('b', [_vm._v(_vm._s(_vm.invite_amount))]), _vm._v(" 位加入“Coleman LINE官方賬號”，"), _c('br'), _vm._v("即可參加抽獎 "), _c('b', [_vm._v("1")]), _vm._v(" 次 ")]), _c('div', {
    staticClass: "friends-list"
  }, _vm._l(_vm.friends, function (friend) {
    return _c('div', {
      key: friend.name,
      staticClass: "friend"
    }, [_c('MgmProfileAvatar', {
      attrs: {
        "pic_url": friend.pic_url
      },
      on: {
        "click": _vm.inviteFriend
      }
    }), _c('div', {
      staticClass: "friend__name"
    }, [_vm._v(_vm._s(friend.name))])], 1);
  }), 0), _c('div', {
    staticClass: "button__wrapper"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.inviteFriend
    }
  }, [_vm._v(" 立即邀請 ")])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_vm._v("邀好友加入"), _c('br'), _vm._v("好禮獎不完")]);
}]

export { render, staticRenderFns }